import React, {useState, useEffect} from 'react'
import { Grid, Paper, TextField, Button } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser, signupUser } from "../../redux/actions/actions";

// Import supabase configuration
import supabase from "../../config/supabase";

function Form({ isLogin }) {
  const navigate = useNavigate();
  
  //Initializing states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { currentUser } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const styleClasses = 'border border-white-1 bg-black-3 text-white-1 text-xl focus:border-2 pl-5 w-4/5 h-12 xl-2:h-20 xl-1:h-14'

  const handleSubmit = async(e) => {
    e.preventDefault();
    var clientUrl = localStorage.getItem("clientUrl") || "";

    var url = clientUrl && clientUrl.slice(clientUrl.indexOf("client"));

    if(isLogin){  
      dispatch(loginUser(email, password))
        .then(() => {
          
          clientUrl && localStorage.setItem("loggedIn", true);
          if(clientUrl){
            navigate(`/${url}`)
          } else{
            localStorage.setItem("admin", true); 
            navigate("/");
          }
        })
        .catch(() => {
          setErrorMessage("Invalid email or password");
          console.log("Error");
        });
    } else {
      if(password === confirmPassword) {
        // Check if email is in database
        var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ email: email});

        if(data && data.length){
          dispatch(signupUser(email, password))
          .then(() => {
            clientUrl && localStorage.setItem("loggedIn", true);
            clientUrl ? navigate(`/${url}`) : navigate("/login");
          })
          .catch(() => {
            setErrorMessage("Invalid email or password");
            console.log("Error");
          });
        }
        else{
          setErrorMessage("Sorry, you can not sign up to our system.");
        }
       
      }
      else {
        setErrorMessage("Password and confirm Password is not same");
      }
    }
  };


  const handleClick = (name) => {
      navigate(name == 'login' ? '/login' : '/signup');
  }
  return (
    <form className='md-1:grid md-1:justify-items-center' onSubmit={handleSubmit}>
        <input 
        type="text" 
        name="email" 
        className={`${styleClasses}`} 
        placeholder='Email' 
        required
        value={email}
        onClick={() => setErrorMessage("")}
        onChange={(e) => {
          setEmail(e.target.value);
        }}/>
        <input 
        type="password" 
        name="Password" 
        className={`mt-5 ${isLogin && 'mb-7'} ${styleClasses}`} 
        placeholder='Password' 
        required
        value={password}
        onClick={() => setErrorMessage("")}
        onChange={(e) => setPassword(e.target.value)}
        />
        {
          !isLogin && 
          <input 
          type="password" 
          name="confirmPassword" 
          className={` mt-5 mb-7 ${styleClasses}`} 
          placeholder='Confirm Password'
          required
          value={confirmPassword}
          onClick={() => setErrorMessage("")}
          onChange={(e) => setConfirmPassword(e.target.value)}
          />
        }
        {
          errorMessage && <div className='text-red-1'>{errorMessage}</div>
        }
        {isLogin ? <div className='text-white-1 text-right xl-2:text-lg w-4/5 mb-7'>Don't have an account? <span className='text-blue-1 underline cursor-pointer' onClick={ (e) => handleClick('signup')}>Create Account</span></div> : <div className='text-white-1 text-right xl-2:text-lg w-4/5 mb-7'>Have an account? <span className='text-blue-1 underline cursor-pointer' onClick={(e) => handleClick('login')}>Login</span></div> }
        <Button
        type="submit"
        color="primary"
        variant="contained"
        className='h-14 w-36 md-1:w-4/5 xl-2:h-20 xl-2:w-56'
        style={{display: 'block'}}
        >
        <span className='text-lg xl-2:text-3xl capitalize'>{isLogin ? 'Log in' : 'Signup'}</span>
        </Button>
    </form>
  )
}

export default Form